/* radiobuttons */
$(document).on('change', '.__radiobuttons input', function() {
    if ($(this).is(':checked')) {
        var inputName = $(this).attr('name');
        $('input[name="'+ inputName +'"]').parents('label').removeClass('__checked')
        $(this)
            .parent('label')
            .addClass('__checked');
    }
});
$('.__radiobuttons input:checked')
    .parent()
    .addClass('__checked');

/* checkboxes */
$(document).on('change', '.__checkbox input', function() {
    if ($(this).is(':checked')) {
        $(this)
            .parent()
            .addClass('__checked');
    } else {
        $(this)
            .parent()
            .removeClass('__checked');
    }
});
$('.__checkbox input:checked')
    .parent()
    .addClass('__checked');

/* focus styling */
$(document).ready(function() {
    $('.field_wrap.__radiobuttons input, .field_wrap.__checkbox input').focus(function() {
        $(this)
            .closest('label')
            .addClass('__focused');
    }).blur(function() {
        $(this)
            .closest('label')
            .removeClass('__focused');
    });
});

$(document).ready(function() {
    $('.field_wrap.__text input, .field_wrap.__textarea textarea, .field_wrap.__number input').focus(function() {
        $(this)
            .parents('.field_wrap')
            .addClass('__focused');
    }).blur(function() {
        $(this)
            .parents('.field_wrap')
            .removeClass('__focused');
    });
});

// Select with no search
$('.__select select').each(function() {
    var selectId = $(this).parent();
    $(this).select2({
        containerCssClass: 'select2-css',
        minimumResultsForSearch: Infinity,
    })
});
// Select with no search
$('.__selectwithsearch select').each(function() {
    var selectId = $(this).parent();
    $(this).select2({
        containerCssClass: 'select2-css',
    })
});

// Select multiple options
$('.__multiselect select').each(function() {
    var selectId = $(this).parent();
    $(this).select2({
        containerCssClass: 'select2-css',
        minimumResultsForSearch: Infinity,
        multiple: true,
    })
});

// Select with images
function formatSelectWithImage (select) {
    var select = select.element;
    var imagePath = "/images/flags/";
    var injectImage = $('<span class="select2-template-image"><img src="' + imagePath + $(select).data('image') + '">' +  $(select).text() + '</span>');
    return injectImage;
};
$('.__selectwithimages select').each(function() {
    var selectId = $(this).parent();
    $(this).select2({
        containerCssClass: 'select2-css',
        // minimumResultsForSearch: Infinity,
        templateResult: formatSelectWithImage,
        templateSelection: formatSelectWithImage,
    });
});

// Add filled styling
// $('.main .field_wrap input, main .field_wrap textarea').each(function() {
//     var input = $(this);
//     var parent = input.parents('.field_wrap');
//     if (input && input.val()) {
//         parent.addClass('__filled')
//     }
// });
// $('body').on('change', '.main .field_wrap input, .main .field_wrap select, main .field_wrap textarea', function() {
//     var input = $(this);
//     var parent = input.parents('.field_wrap');
//     if (input && input.val()) {
//         parent.addClass('__filled')
//     } else {
//         parent.removeClass('__filled')
//     }
// });

function prependInputs(){
    // Prepend symbols onto inputs
    if ($('[data-prepend]').length) {
        $('[data-prepend]').each(function(){
            var prepend = $(this).data('prepend')
            $(this).find('.input_wrap').prepend('<span class="input-prepend">'+prepend+'</span>')
        })
    }
}
function appendInputs(){
    // Append symbols onto inputs
    if ($('[data-append]').length) {
        $('[data-append]').each(function(){
            var append = $(this).data('append')
            $(this).find('.input_wrap').prepend('<span class="input-append">'+append+'</span>')
        })
    }
}

$(document).ready(function() {
    prependInputs();
    appendInputs();
});



// Prepend symbols onto inputs
